'use client';

import { JobEntity } from '@/components/ui/design-system/entities/job';
import { ContactEntity } from '@/components/ui/design-system/entities/contact';
import { cn } from '@/lib/utils';
import type { JobWithContacts as JobWithContactsData } from '../types';

interface JobWithContactsProps {
  data: JobWithContactsData;
  className?: string;
}

/**
 * Renders a job row, then up to 2 contacts indented underneath as the
 * "people you'd actually talk to about this job". The relevance threshold
 * is enforced upstream; this component just displays whatever it's given.
 */
export function JobWithContactsCard({ data, className }: JobWithContactsProps) {
  const { job, contacts } = data;

  return (
    <div className={cn('space-y-1.5', className)}>
      <JobEntity
        job={job}
        layout="card"
        density="compact"
        actions={{ apply: true, contactHiringManager: true }}
      />
      {contacts.length > 0 ? (
        <div className="ml-2 border-l border-border/60 pl-2.5 space-y-1.5 sm:ml-5 sm:pl-3.5">
          <p className="text-[10px] font-semibold uppercase tracking-[0.16em] text-muted-foreground">
            People at {job.company.name}
          </p>
          {contacts.map((contact) => (
            <ContactEntity
              key={contact.id}
              contact={contact}
              layout="row"
              density="compact"
              fields={{ relevance: true, location: true, seniority: true }}
            />
          ))}
        </div>
      ) : null}
    </div>
  );
}
